/* eslint-disable jira/filename-case */

import setupUFOGlobalErrorHandler from '@atlaskit/react-ufo/setup-ufo-global-error-handler';
import { installErrorHandler } from '@atlaskit/report-error';
import { installGlobalHandler } from '@jira/platform__error-reporting/src/sentry/initialization.tsx';
import { platformErrorHandler } from '@jira/platform__observability-platform-errors-handling/src/platformErrorHandler.tsx';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';

if (!killswitch('fe_platform_error_tracking_enabled_sentry')) {
	installGlobalHandler();
}

installErrorHandler(platformErrorHandler);

setupUFOGlobalErrorHandler();
